import './SearchNavigationTab.scss';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { LocationDescriptor } from 'history';
import { bind } from 'lodash-decorators/bind';
import { SearchParams } from 'src/state/SearchParams';
import { SearchResultSectionType } from 'src/state/SearchResult';

type Props = {
    readonly params: SearchParams;
    readonly section: SearchResultSectionType | null;
};

export class SearchNavigationTab extends React.Component<Props> {
    public render(): JSX.Element {
        const { children } = this.props;

        return (
            <NavLink to={this.getLinkLocation()}
                     isActive={this.isActive}
                     replace={true}
                     className="lvo-search-navigation-tab"
                     activeClassName="lvo-search-navigation-tab--active">
                {children}
            </NavLink>
        );
    }

    private getLinkLocation(): LocationDescriptor {
        const { params: { query }, section } = this.props;
        return section
            ? `?query=${encodeURIComponent(query)}&section=${encodeURIComponent(section)}`
            : `?query=${encodeURIComponent(query)}`;
    }

    @bind()
    private isActive(): boolean {
        const { params, section } = this.props;
        return params.section === section;
    }
}
